import {Menu, MenuProps} from "antd";
import React, {useState} from "react";
import './NavigationStyles.scss';
import {ToolOutlined, WechatOutlined} from "@ant-design/icons";

const menuItems: MenuProps['items'] = [
    {
        label: 'Задание',
        key: 'task',
        icon: <ToolOutlined/>,
    },
    {
        label: 'Чат',
        key: 'chat',
        icon: <WechatOutlined/>,
    },
]

export const Navigation = (props: any) => {


    const onClick: MenuProps['onClick'] = (e) => {
        props.setCurrentMenuItem(e.key);
    };
    return (
        <Menu className="centeredItems" onClick={onClick} selectedKeys={[props.currentMenuItem]} mode="horizontal"
              items={menuItems}/>
    )
}